const NavBar = () => {
  return(

    <nav className="navbar bg-dark text-light mb-5">
      <div className="container-fluid">
        <h3 className="mx-auto">Predicción Meteorológica</h3>
      </div>
    </nav>
  );

}

export default NavBar;
